export default "__VITE_ASSET__ClI3tH6U__"